(function () {
  'use strict';

  console.log('[Badge Fix] Script geladen');

  let active = false;

  function fixBadge(badge) {
    if (!active || !badge.classList.contains('smart-ai-badge')) {
      return;
    }

    const value = badge.style.getPropertyValue('z-index');
    const priority = badge.style.getPropertyPriority('z-index');

    if (value !== '1' || priority !== 'important') {
      badge.style.setProperty('z-index', '99', 'important');
      console.log('[Badge Fix] z-index korrigiert:', badge);
    }
  }

  function fixAllBadges() {
    document.querySelectorAll('.smart-ai-badge').forEach(fixBadge);
  }

  const observer = new MutationObserver(function (mutations) {
    if (!active) return;

    mutations.forEach(function (mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        fixBadge(mutation.target);
      }

      if (mutation.type === 'childList') {
        fixAllBadges();
      }
    });
  });

  function init() {
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.btnCustomization')) return;

      active = true;

      console.log('[Badge Fix] Customization geöffnet');

      fixAllBadges();
    });

    console.log('[Badge Fix] Überwachung bereit');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();